import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import queryString from 'query-string';

import clsx from 'clsx';

import RenameBasAgentModal from '../../Modals/RenameBasAgentModal';
import BobLoadingMask from '../../../../components/BobLoadingMask';
import BobConfirmButton from '../../../../components/BobConfirmButton';
import AssignBasAgentModal from '../../Modals/AssignBasAgentModal';
import DeleteBasAgentModal from '../../Modals/DeleteBasAgentModal';
import FactoryResetBasAgentModal from '../../Modals/FactoryResetBasAgentModal';
import BobPage from '../../../../components/BobPage';
import Breadcrumb from '../../../../components/Breadcrumb/Breadcrumb';
import Navigation from '../../Navigation/Navigation';
import AgentDetailsPanel from './AgentDetailsPanel';
import DevicesPanel from './DevicesPanel';

import * as BasAgentActions from '../../../../actions/basAgentActions';
import * as IotHubActions from '../../../../actions/iotHubActions';

import * as classes from './ManageAgentPage.module.css';

const ManageAgentPage = ({
    activeNavCompany,
    bobLoading,
    fetchBasAgent,
    fetchDevicesAndObjects,
    history,
    selectedAgent,
    setSelectedAgent,
    ...props
}) => {
    const [renameAgentModalOpen, setRenameAgentModalOpen] = useState(false);
    const [assignAgentModalOpen, setAssignAgentModalOpen] = useState(false);
    const [deleteAgentModalOpen, setDeleteAgentModalOpen] = useState(false);
    const [factoryResetAgentModalOpen, setFactoryResetAgentModalOpen] = useState(false);
    const [deviceObjects, setDeviceObjects] = useState(null);

    const queryValues = queryString.parse(history.location.search);

    useEffect(() => {
        const init = async () => {
            if (isEmpty(selectedAgent)) {
                const agent = await fetchBasAgent(queryValues.agent);
                setSelectedAgent(agent);
                const objects = await fetchDevicesAndObjects(agent.id, agent.driverConfiguration[0].id);
                setDeviceObjects(objects);
            } else {
                if (selectedAgent.id !== queryValues.agent) {
                    const agent = await fetchBasAgent(queryValues.agent);
                    setSelectedAgent(agent);
                }
                const objects = await fetchDevicesAndObjects(selectedAgent.id, selectedAgent.driverConfiguration[0].id);
                setDeviceObjects(objects);
            }
        };

        if (activeNavCompany.id) init();
    }, [activeNavCompany]);

    const handleNavigation = () => {
        setSelectedAgent({});
        const path = '/v2/dashboard/iothub';
        const updatedUrl = history.location.search.replace(/[?&]agent=[^&]+/, '').replace(/^&/, '?');

        history.push({ pathname: path, search: updatedUrl });
    };

    return (
        <React.Fragment>
            <BobPage>
                <div className={classes.CompanyPage}>
                    <div className={classes.BreadcrumbPanel}>
                        <Breadcrumb />
                    </div>
                    <div className={classes.HeaderPanel}>
                        <div className={classes.NavigationPanel}>
                            <Navigation />
                        </div>
                    </div>
                    <div className={classes.TitlePanel}>
                        <span><i role="none" onClick={() => handleNavigation()} className={clsx('fas fa-angle-left fa-lg', classes.Arrow)} /></span>
                        <span className={classes.Label}>Devices & Objects</span>
                    </div>
                    <div className={classes.DataPanel}>
                        <AgentDetailsPanel
                            setRenameAgentModalOpen={setRenameAgentModalOpen}
                            setAssignAgentModalOpen={setAssignAgentModalOpen}
                            setDeleteAgentModalOpen={setDeleteAgentModalOpen}
                            setFactoryResetAgentModalOpen={setFactoryResetAgentModalOpen}
                            selectedAgent={selectedAgent}
                        />
                    </div>
                    <div className={classes.TablePanel}>
                        <DevicesPanel
                            deviceObjects={deviceObjects}
                            selectedAgent={selectedAgent} 
                        />
                    </div>
                    <div className={classes.ButtonPanel}>
                        <span className={classes.Button}>
                            <BobConfirmButton
                                disabled={isEmpty(deviceObjects)}
                                className={isEmpty(deviceObjects) ? classes.DisabledButtons : classes.Buttons}
                                label={'Save'}
                                iconSize={15}
                            />
                        </span>
                    </div>
                </div>
            </BobPage>
            {
                deviceObjects === null ?
                    <BobLoadingMask />
                    :
                    null
            }
            {
                factoryResetAgentModalOpen ?
                    <FactoryResetBasAgentModal
                        agent={selectedAgent}
                        setFactoryResetAgentModalOpen={setFactoryResetAgentModalOpen}
                    />
                    :
                    null
            }
            {
                deleteAgentModalOpen ?
                    <DeleteBasAgentModal
                        agent={selectedAgent}
                        setDeleteAgentModalOpen={setDeleteAgentModalOpen}
                    />
                    :
                    null
            }
            {
                renameAgentModalOpen ?
                    <RenameBasAgentModal
                        agent={selectedAgent}
                        setRenameAgentModalOpen={setRenameAgentModalOpen}
                    />
                    :
                    null
            }
            {
                assignAgentModalOpen ?
                    <AssignBasAgentModal
                        agent={selectedAgent}
                        setAssignAgentModalOpen={setAssignAgentModalOpen}
                    />
                    :
                    null
            }
        </React.Fragment>
    );
};

const mapStateToProps = state => ({
    activeNavCompany: state.bob.activeNavCompany,
    bobLoading:       state.bob.bobLoading,
    basAgents:        Object.values(state.basAgent.basAgents),
    selectedAgent:    state.basAgent.selectedAgent
});

const mapDispatchToProps = {
    ...BasAgentActions,
    ...IotHubActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ManageAgentPage));
